import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateNone: SceneTemplate = {
    name: "ללא תבנית",
    branding: {
        background: "primary",
        foreground: undefined,
    },
    aspectRatio: "16:9",
    avatar: undefined,
    scene: {
        scale: 100,
        rounded: false,
        location: {
            x: 0,
            y: 0,
        },
    },
};
